import { axiosFactory } from '../../../../client';
import { CandidateProfileResponse } from '../models';
import * as ROUTES from './routes';

const baseURL = `${import.meta.env.VITE_APP_API_DOMAIN}/candidate/api`;
const timeout = 5000;

export const candidateClient = axiosFactory(baseURL, timeout);

/** to update candidate particular
 * @param candidateParticular
 * */
export const putCandidateParticular = async (
  csrfToken: string,
  candidateParticular: CandidateProfileResponse
) =>
  candidateClient.put<undefined>(
    csrfToken,
    `${ROUTES.UPDATE_CANDIDATE_PARTICULAR}`,
    candidateParticular
  );

/** to get candidate particular
 * */
export const getCandidateParticular = () =>
  candidateClient.get<CandidateProfileResponse>(ROUTES.GET_CANDIDATE_PARTICULAR);
